import React, { useState, useEffect } from 'react';
import api from '../../config/axios';

const NaturezaServicoSelect = ({ value, onChange, className, darkMode = false }) => {
  const [naturezas, setNaturezas] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchNaturezas = async () => {
      try {
        setLoading(true);
        const response = await api.get('/naturezas-rendimento');
        setNaturezas(response.data);
        setError(null);
      } catch (err) {
        console.error('Erro ao carregar naturezas de serviço:', err);
        setError('Erro ao carregar naturezas de serviço');
      } finally {
        setLoading(false);
      }
    };

    fetchNaturezas();
  }, []);

  const selectClassName = `w-full px-4 py-2.5 rounded-lg border focus:ring-2 focus:ring-indigo-500 focus:border-transparent ${
    darkMode 
      ? 'bg-slate-900 text-white border-slate-600 placeholder-slate-400' 
      : 'bg-white text-gray-900 border-gray-300'
  } ${className || ""}`;

  if (loading) {
    return (
      <select 
        disabled 
        className={selectClassName}
      >
        <option>Carregando...</option>
      </select>
    );
  }

  if (error) {
    return (
      <select 
        disabled 
        className={selectClassName}
      >
        <option>Erro ao carregar</option>
      </select>
    );
  }

  return (
    <select
      value={value || ''}
      onChange={(e) => onChange(e.target.value)}
      className={selectClassName}
      required
    >
      <option value="">Selecione a natureza do serviço</option>
      {naturezas.map((natureza) => (
        <option key={natureza.id} value={natureza.codigo}>
          {natureza.codigo} - {natureza.descricao}
        </option>
      ))}
    </select>
  );
};

export default NaturezaServicoSelect;
